import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router'

// create an axios instance
export const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30000,
})
// request interceptor
service.interceptors.request.use(
  config => {

    if (store.getters.token) {
      config.headers['Login-Token'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log('request err', error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
let messageAll;
service.interceptors.response.use(
  response => {
    const res = response.data
    // console.log(res)
    if (res.code == -1) {//token 无效失效
      store.dispatch('user/resetToken').then(() => {
        router.push({
          path: '/login',
          query: { redirect: router.currentRoute.fullPath }
        })
        if (messageAll) {
          messageAll.close()
        }
        console.log('登录失效，请重新登录')
        messageAll = Message({
          message: '登录失效，请重新登录',
          type: 'error',
          duration: 3 * 1000
        })
      })
      return Promise.reject(new Error(res.message || 'Error'))
    }else if( res==0 && res.code!='0' && res.code!='200'){// 请求失败的code/非请求成功的code
      // if (messageAll) {
      //   messageAll.close()
      // }
      // messageAll = Message({
      //   message: res.message||res.msg|| '请求失败',
      //   type: 'error',
      //   duration: 3 * 1000
      // })
      return Promise.reject(new Error(res || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('请求错误:' + error) // for debug
    Message({
      message: error.message || '请求错误',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)